import { render } from "./IconSelection.vue?vue&type=template&id=5c93e94a&scoped=true"
import script from "./IconSelection.vue?vue&type=script&lang=js"
export * from "./IconSelection.vue?vue&type=script&lang=js"

import "./IconSelection.vue?vue&type=style&index=0&id=5c93e94a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5c93e94a"

export default script